import React from 'react';
import FinanceHeaderContextProvider from '../../components/context/FinanceHeaderContextProvider';
import SideNavContextProvider from '../../components/context/SideNavContextProvider';
import Finances from './Approval-management';

const Index = () => {
  return (
    <FinanceHeaderContextProvider>
      <SideNavContextProvider>
        <Finances />
      </SideNavContextProvider>
    </FinanceHeaderContextProvider>
  );
};

export default Index;
